<template>
  <div class="xcard">
    <button
      :disabled="$store.state.isonlyread"
      v-show="datos.length > 0"
      class="btn btn-sm btn-link"
      @click="tableToExcel('table', 'Lorem Table')">
      <span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL
    </button>
    <div class="table-responsive">
      <table class="xtable table-hover" ref="table">
        <thead class="text-center green darken-4 white--text">
          <tr class="white--text">
            <th class="text-center fixedheader" rowspan="3">Sede</th>
            <th :colspan="hpagos.length">Recaudado</th>
          </tr>
          <tr class="white--text">
            <th v-for="(hc, ind) in hconceptos" :key="ind" :colspan="hc.xcolspan.length">
              {{ hc.xconcepto_pago_nombre }}
            </th>
          </tr>
          <tr class="white--text">
            <th v-for="(hp, ind) in hpagos" :key="ind">{{ hp.title }}</th>
          </tr>
        </thead>
        <tbody class="text-right">
          <tr class="cuerpo" v-for="(d, ind) in datos" :key="ind">
            <td class="text-left">{{ d.nombre }}</td>
            <td v-for="(r, ind2) in d.columnas" :key="ind2">{{ parsecomas(r.monto) }}</td>
          </tr>
          <tr class="text-right green darken-4">
            <td style="background: #196391; color: white" class="text-right">TOTAL</td>
            <td v-for="(t, ind2) in totales" :key="ind2" style="color: white !important">{{ parsecomas(t.xmonto) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="my-0 text-center">{{ msg }}</p>
    <hr />
  </div>
</template>

<style lang="css">
  table tbody td:first-child {
    position: sticky;
    left: 0;
    background: #eaf1ff;
    z-index: 0;
    text-align: left;
  }
  .cuerpo td:last-child {
    position: sticky;
    left: 0;
    background: #b1720c;
    color: white;
    z-index: 0;
    text-align: right;
  }
  .fixedheader {
    position: sticky;
    left: 0;
    background: #196391;
    z-index: 1;
    text-align: left;
  }
  .xtable {
    width: 100%;
    border: 1px solid black;
    font-size: 0.9em;
  }
  .xtable th {
    border: 1px solid black;
    padding-right: 0.5em;
    padding-left: 0.5em;
    padding-top: 0.2em;
    padding-bottom: 0.2em;
    text-align: center;
  }
  .xtable td {
    border: 1px solid black;
    padding-left: 4px;
    padding-right: 4px;
    padding-top: 0.2em;
    padding-bottom: 0.2em;
  }
  .xtable th:first-child {
    min-width: 100px;
  }
</style>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        // EXCEL
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        },
        // END EXCEL
        sedes: [],
        datos: [],
        hconceptos: [],
        hpagos: [],
        totales: [],
        msg: '',
      };
    },
    watch: {},
    components: {},
    methods: {
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table;
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
        var link = document.createElement('a');
        link.download = 'REPORTE_RECAUDACION_MENSUAL_POR_UNIDAD_DE_NEGOCIO.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      obtenerasignaciones(mes, anio, unidadid, convenio) {
        const vue = this;
        this.hconceptos = [];
        this.hpagos = [];
        this.datos = [];
        this.totales = [];
        this.msg = '';
        let urla = `${process.env.VUE_APP_API_REST}/api/v2/recaudacion/unidad_negocio?month=${mes}&year=${anio}&unidad_negocio_id=${unidadid}&universidad_id=${convenio}`;
        window.console.log(urla);
        const promise1 = xaxios.get(urla);
        Promise.all([promise1])
          .then(function (values) {
            if (!values[0] || !values[0].data) values[0] = { data: { data: [] } };
            let data1 = JSON.parse(JSON.stringify(values[0].data.data));

            data1.forEach((x) => {
              x.recaudaciones.forEach((r) => {
                if (r.concepto_pago_nombre == 'Matricula') r.xindex = 0;
                else if (r.concepto_pago_nombre == 'Colegiatura') r.xindex = 1;
                else if (r.concepto_pago_nombre == 'Certificación') r.xindex = 2;
                else if (r.concepto_pago_nombre == 'Otros Ingresos') r.xindex = 3;
                else r.xindex = 4;

                r.pagos.forEach((p) => {
                  if (p.tipo == 'total_sin_marketing') p.xindex = 0;
                  else if (p.tipo == 'marketing') p.xindex = 1;
                  else if (p.tipo == 'vigente') p.xindex = 2;
                  else if (p.tipo == 'adelantado') p.xindex = 3;
                  else if (p.tipo == 'retrasado') p.xindex = 4;
                  else if (p.tipo == 'por_recuperar') p.xindex = 5;
                  else if (p.tipo == 'total') p.xindex = 6;
                  else p.xindex = 7;
                });
              });
            });

            data1.forEach((x) => {
              x.recaudaciones.sort((a, b) => {
                return a.xindex - b.xindex;
              });
              x.recaudaciones.forEach((r) => {
                r.pagos.sort((a, b) => {
                  return a.xindex - b.xindex;
                });
              });
            });

            data1.sort((a, b) => {
              let aux = 0;
              if (a.sede_id > b.sede_id) aux = 1;
              else if (a.sede_id < b.sede_id) aux = -1;
              return aux;
            });

            data1.forEach((x) => {
              x.recaudaciones.forEach((r) => {
                if (r.concepto_pago_nombre == 'Certificación') {
                  r.pagos = r.pagos.filter((p) => {
                    let dist = p.tipo != 'total_sin_marketing' && p.tipo != 'marketing';
                    return dist;
                  });
                } else if (r.concepto_pago_nombre == 'Colegiatura') {
                  r.pagos = r.pagos.filter((p) => {
                    let dist = p.tipo != 'total_sin_marketing';
                    return dist;
                  });
                } else if (r.concepto_pago_nombre == 'Otros Ingresos') {
                  r.pagos = r.pagos.filter((p) => {
                    let dist = p.tipo != 'total_sin_marketing' && p.tipo != 'marketing';
                    return dist;
                  });
                } else if (r.concepto_pago_nombre == 'Matricula') {
                  r.pagos = r.pagos.filter((p) => {
                    let dist = p.tipo != 'total_sin_marketing' && p.tipo != 'marketing';
                    return dist;
                  });
                }
              });
            });

            //window.console.log(data1);

            // window.console.log('DATOS:', JSON.stringify(data1, null, 4));

            data1.forEach((e) => {
              e.recaudaciones.forEach((r) => {
                let con = vue.hconceptos.find((x) => x.xconcepto_pago_id == r.concepto_pago_nombre);
                if (!con) {
                  con = {
                    xconcepto_pago_id: r.concepto_pago_nombre,
                    xconcepto_pago_nombre: r.concepto_pago_nombre,
                    xcolspan: [],
                  };
                  vue.crearhpago(r, con);
                  vue.hconceptos.push(con);
                } else {
                  vue.crearhpago(r, con);
                }
              });
            });

            let con = {
              xconcepto_pago_id: 100,
              xconcepto_pago_nombre: '',
              xcolspan: [{ tipo: 'xtotal', title: '', xconcepto_pago_id: 100 }],
            };
            vue.hconceptos.push(con);

            let xdatos = [];
            let xtotalsedes = 0;
            data1.forEach((d) => {
              let sede = {};
              sede.nombre = d.sede.sede_nombre;
              sede.columnas = [];
              let xtotal = 0;
              vue.hpagos.forEach((p) => {
                let pagos = d.recaudaciones.find((r) => r.concepto_pago_nombre == p.xconcepto_pago_id);
                if (!pagos) pagos = { pagos: [] };
                let ex = pagos.pagos.find((ep) => ep.tipo == p.tipo);
                if (ex) {
                  sede.columnas.push(ex);
                  xtotal += ex.monto;
                } else sede.columnas.push({ monto: '' });
              });
              xtotalsedes += xtotal;
              sede.columnas.push({ monto: xtotal });
              xdatos.push(sede);
              //window.console.log('TOTAL SEDE::', xtotal);
            });
            //segunda fila columna total
            vue.hpagos.push({ tipo: 'xtotal', title: 'Total sede', xconcepto_pago_id: 100 });
            vue.totales.push({ xconcepto_pago_id: 100, tipo: 'xtotal', xmonto: xtotalsedes });

            vue.datos = xdatos;
            //window.console.log('DATA:', JSON.stringify(data1, null, 4));
            vue.$emit('dataloaded');

            //window.console.log(JSON.stringify(vue.hpagos, null, 4));
          })
          .catch((e) => {
            window.console.error(e);
            try {
              window.console.error(e.response.data.data.Message);
            } catch (e) {
              window.console.error(e);
            }
            if (e.response.status == 500) {
              vue.msg =
                '(500) Actualmente estamos teniendo inconvientes al obtener los datos, lamentamos las molestias causadas :)';
            }
            vue.$emit('dataloaded');
          });
      },
      crearhpago(r, con) {
        const vue = this;
        r.pagos.forEach((p) => {
          //window.console.log('pp>>', r.concepto_pago_nombre, p.tipo, p.monto);
          let xt = vue.totales.find((t) => t.xconcepto_pago_id == r.concepto_pago_nombre && t.tipo == p.tipo);
          if (!xt) vue.totales.push({ xconcepto_pago_id: r.concepto_pago_nombre, tipo: p.tipo, xmonto: p.monto });
          else xt.xmonto += p.monto;
          let pagoexiste = con.xcolspan.find((xc) => xc.tipo == p.tipo);
          if (!pagoexiste) {
            let xp = { tipo: p.tipo, title: p.title, xconcepto_pago_id: r.concepto_pago_nombre };
            con.xcolspan.push(xp);
            vue.hpagos.push(xp);
          }
        });
      },
      parsecomas(str) {
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
    },
    mounted() {},
  };
  ('');
</script>
